<template>
    <v-sheet>
        <v-row>
            <v-col cols="12" md="12">
                <v-sheet outlined>
                   <!-- Error -->
                    <div v-if="errors.length > 0" class="text-center pa-4">
                        <div class="mb-2 error--text" v-for="(e, i) in errors" :key="i">{{e}}</div>
                        <v-btn text @click="fetchCustomerSalesScheduling">
                            <v-icon left>mdi-refresh</v-icon>
                            Try Again
                        </v-btn>
                    </div>
                    <!-- No Data -->
                    <div v-else-if="data.length == 0" class="text-center pa-4">
                        <div class="mb-4">This customer doesn't have  Salse Schedules</div>
                        <v-btn text @click="handleScheduleOpen">
                            <v-icon left>mdi-calendar</v-icon>
                            Schedule Sales Now
                        </v-btn>
                    </div>
                    <!-- Data -->
                    <v-simple-table v-else dense>
                        <thead>
                            <tr class="surface">
                                <th>Date</th>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Cast Type</th>
                                <th>Site</th>
                                <th>State</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(d, i) in data" :key="i" v-ripple @click="handleScheduleRowClick(d.start_at)">
                                <td>{{d.start_at}}</td>
                                <td>{{d.item}}</td>
                                <td>{{d.quantity}}</td>
                                <td>{{d.cast_type}}</td>
                                <td>{{d.site}}</td>
                                <td>
                                    <v-badge inline left dot :color="renderColor(d.state_id)"></v-badge>
                                    {{d.state}}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-sheet>
            </v-col>
        </v-row>
        <v-snackbar 
            v-model="snackbar.display" 
            :color="snackbar.color"
            right bottom>
            {{snackbar.message}}
        </v-snackbar>
        <v-overlay v-model="loading">
            <v-sheet color="white" class="pa-4" width="300" elevation="1" rounded>
                <v-progress-linear indeterminate color="primary"/>
                <div class="primary--text text-center mt-2">Please Wait ...</div>
            </v-sheet>
        </v-overlay>
    </v-sheet>
</template>

<script>
import { getSalesSchedules } from '../../services/scheduling/schedule';
import { states } from './../../data/sales/scheduling/states';

export default {
    name: "CustomerSalesSchedulingList",
    props: {
        customerId: [String, Number]
    },
    data() {
        return {
            data: [],
            errors: [],
            snackbar: {},
            loading: false
        }
    },
    methods: {
        handleScheduleNavigation() {
            this.$router.push("/sales/scheduling");
        },
        async fetchCustomerSalesScheduling() {
            this.clearErrors();
            try {
                this.loading = true;
                let resp = await getSalesSchedules({customerIds: [this.customerId]});
                this.data = resp.data;  
                this.loading = false;
            } catch (error) {
                let message = error.response ? error.response.data.message : error;
                this.setError(message);
                this.loading = false;
            }
        },
        setError(message) {
            this.errors.push(message);
            this.snackbar = { display: true, color: "error", message };
        },
        clearErrors() {
            this.errors.splice(0, this.errors.length);
        },
        renderColor(stateId) {
            let state = states.find(each => each.id == stateId);
            return state ? state.color : "black";
        },
        handleScheduleRowClick(date) {
            this.$router.push({path: "/sales/scheduling", query: { date, type: "day" }})
        },
        handleScheduleOpen() {
            this.$router.push("/sales/scheduling");
        }
    },
    created() {
        this.fetchCustomerSalesScheduling();
    }
}
</script>

<style>

</style>